export default __webpack_public_path__ + "static/media/supper_apps_background_m1.d6c37515.jpg";